import closeIcon from '@jetbrains/icons/close'
import Theme, {ThemeProvider} from '@jetbrains/ring-ui-built/components/global/theme'
import {Button, IconButton} from '@jetbrains/teamcity-ui/dist/components'
import {useCallback} from 'react'

import {useSetUserProperty} from '../../../../../hooks/useSetUserProperty'
import {useBooleanUserProperty} from '../../../../../hooks/useUserProperty'
import {isPipelinesClassicUIBannerEnabled} from '../../../../../utils/featureToggles'
import {UserProperties} from '../../../../../utils/userProperties'

import styles from './PipelinesClassicUIBanner.module.css'

export type PipelinesClassicUIBannerProps = {
  href: string
}

function PipelinesClassicUIBanner({href}: PipelinesClassicUIBannerProps) {
  const setUserProperty = useSetUserProperty()
  const isShow = useBooleanUserProperty(UserProperties.SHOW_PIPELINES_CLASSIC_UI_BANNER, true)

  const dismiss = useCallback(
    () => setUserProperty(UserProperties.SHOW_PIPELINES_CLASSIC_UI_BANNER, 'false'),
    [setUserProperty],
  )

  if (!isPipelinesClassicUIBannerEnabled || !isShow) {
    return null
  }

  return (
    <ThemeProvider theme={Theme.DARK}>
      <div className={styles.banner}>
        <div className={styles.message}>
          {'Pipelines are now in early access! '}
          <Button inline href={href}>
            {'Switch to Sakura UI'}
          </Button>
          {' to explore the intelligent visual editor and YAML support'}
        </div>
        <IconButton
          className={styles.dismissButton}
          title={'Dismiss'}
          onClick={dismiss}
          icon={closeIcon}
        />
      </div>
    </ThemeProvider>
  )
}

export default PipelinesClassicUIBanner
